<template>
  <div>
    <q-select
      v-model="fornecedor"
      :options="listaFornecedor"
      dense
      outlined
      @filter="filterFn"
      option-label="nome"
      option-value="id"
      behavior="menu"
      label="Selecione o Fornecedor"
      label-color="grey-6"
      use-input
      input-debounce="300"
      :bg-color="!desabilitado ? 'brand-7' : ''"
      :disable="!desabilitadoValue"
    />
  </div>
</template>

<script>
import { ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

export default {
  props: [
    "unidadeId",
    "resetar",
    "model",
    "desabilitado",
    "unidadeTransferenciaId",
    "obrigatorioUnidadeId",
  ],
  emits: ["enviarFornecedor"],
  setup(props, { emit }) {
    const store = useStore();
    const quasar = useQuasar();
    const desabilitadoValue = computed(() => props.desabilitado);

    const fornecedor = ref(props.model);
    const listaFornecedor = ref([]);

    const listarFornecedor = async (val) => {
      if (props.obrigatorioUnidadeId) {
        if (
          (props.unidadeId === "" || props.unidadeId === undefined) &&
          (props.unidadeTransferenciaId === "" ||
            props.unidadeTransferenciaId === undefined)
        ) {
          quasar.notify({
            message: "Selecione a unidade.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          listaFornecedor.value = [];
          return;
        }
      }
      try {
        const response = await store.dispatch("ter/listarParceiros", {
          unidadeId:
            store.state.autenticacao.cliente.indexOf("staging-acciona") == 0 ||
            store.state.autenticacao.cliente.indexOf("acciona") == 0
              ? 38
              : props.unidadeId || props.unidadeTransferenciaId || "",
        });
        listaFornecedor.value = response.response.data.resultado.dados;
        const needle = val.toLowerCase();
        listaFornecedor.value = listaFornecedor.value.filter(
          (v) => v.nome.toLowerCase().indexOf(needle) > -1
        );
      } catch (error) {
        console.log(error);
      }
    };

    watch(
      () => fornecedor.value,
      () => {
        emit("enviarFornecedor", fornecedor.value);
      }
    );

    watch(
      () => props.resetar,
      () => {
        fornecedor.value = "";
      }
    );

    watch(
      () => props.model,
      () => {
        if (fornecedor.value?.parceiroId === props.model.id) {
          return;
        }
        fornecedor.value = props.model;
      }
    );

    return {
      fornecedor,
      listarFornecedor,
      listaFornecedor,
      desabilitadoValue,
      filterFn(val, update) {
        listarFornecedor(val);
        setTimeout(() => {
          update();
        }, 200);
      },
    };
  },
};
</script>
